import { cn, Popover, PopoverContent, PopoverTrigger } from '@readcloud/ui';
import {
  Annotation,
  KnownCloud,
  KnownUser,
  OverlayAnnotation,
  UserPrefState,
} from '@readcloud/data';
import React, { RefObject, useEffect } from 'react';
import AnnotationToolbarModals from './AnnotationToolbarModals';
import AnnotationToolbarPopovers from './AnnotationToolbarPopovers';
import { FaRegEdit } from "react-icons/fa";

// Use this onTransitionEnd to solve the issue where inner content of a popover isn't sized properly (eg with tabs)

interface Props {
  containerRef: RefObject<HTMLDivElement>;
  outerContainer: HTMLDivElement;
  pagesContainer: HTMLDivElement;
  pageContainer: HTMLDivElement;
  annotation: Annotation;
  reference?: HTMLElement;
  onDelete: (id: string) => void;
  onComment: (id: string) => void;
  onChange: (annotation: Annotation) => void;
  knownUsers: KnownUser[];
  knownClouds: KnownCloud[];
  showPublisherOptions: boolean;
  zIndex: number;
  onSavePreferences?: (type: string, data: Partial<Annotation['data']>) => void;
  annoPrefs?: UserPrefState['annoPrefs'];
  scale?: number;
}

export const AnnotationToolbar: React.FC<Props> = (props) => {
  const [editOpen, setEditOpen] = React.useState<boolean>(false);
  const [shareOpen, setShareOpen] = React.useState<boolean>(false);

  const { x, y, width, height } = React.useMemo(() => {
    const { x, y, width, height } = (props.annotation as OverlayAnnotation)
      ?.data?.rect;
    return {
      x: x * props.scale || 1,
      y: y * props.scale || 1,
      width: width * props.scale || 1,
      height: height * props.scale || 1,
    };
  }, [props.annotation, props.scale]);

  useEffect(() => {
    console.log('props.pageContainer', props.pageContainer);
  }, [props.pageContainer]);

  return (
    <>
      <Popover open={!!props.reference}>
        <PopoverTrigger asChild>
          <div
            className="rc-absolute"
            style={{
              top: y,
              left: x,
              width: width,
              height: height,
            }}
          ></div>
        </PopoverTrigger>
        <PopoverContent
          sideOffset={16}
          portalled={false}
          className="rc-p-0 rc-border-0 rc-pointer-events-auto rc-z-[1500] rc-h-16 sm:rc-block rc-hidden"
          collisionPadding={{ top: 32, bottom: 32, left: 32, right: 32 }}
          collisionBoundary={props.pageContainer}
        >
          <AnnotationToolbarPopovers
            {...props}
            onEditOpen={setEditOpen}
            editOpen={editOpen}
            onShareOpen={setShareOpen}
            shareOpen={shareOpen}
          />
        </PopoverContent>
      </Popover>
      <Popover open={!!props.reference}>
        <PopoverTrigger asChild>
          {!!props.reference && 
            <div className='sm:rc-hidden rc-absolute rc-bottom-0 rc-h-5 rc-w-full rc-bg-transparent'></div>
          }
        </PopoverTrigger>
        <PopoverContent 
          className='rc-p-0 rc-border-0 rc-pointer-events-auto rc-z-[1500] rc-w-full' 
          portalled={false} 
          collisionPadding={{ top: 32, bottom: 32, left: 32, right: 32 }}
          collisionBoundary={props.pageContainer}
        >
          <AnnotationToolbarModals
            {...props}
            onEditOpen={setEditOpen}
            editOpen={editOpen}
            onShareOpen={setShareOpen}
            shareOpen={shareOpen}
          />
        </PopoverContent>
      </Popover>
    </>
  );
};
